import { useCallback } from "react";

const useLocalStorage = () => {
    const getValue = useCallback((key) => {
        try {
            const item = window.localStorage.getItem(key);
            return item ? JSON.parse(item) : null;
        } catch (error) {
            console.error(error);
            return null;
        }
    }, []);

    const setValue = useCallback((key, value) => {
        try {
            const valueToStore =
                value instanceof Function ? value(getValue(key)) : value;
            window.localStorage.setItem(key, JSON.stringify(valueToStore));
        } catch (error) {
            console.error(error);
        }
    }, [getValue]);

    return { getValue, setValue };
};

export default useLocalStorage;
